import { GameUI } from "game/gameUI/GameUI"
import { translate } from "game/translate"
import { Popups } from "ui/types/popups"

export const OutMoveAdsPopup = () => {
    return (
        <div id="out-move-ads" role="tooltip" className="nomoves_ads modals_area active">
            <div className="wrapper">
                <button type="button" className="close_btn close" onClick={() => GameUI.closePopup(Popups.OUT_MOVE_ADS_POPUP)}></button>
                <div className="text_content">
                    <span className="modals_area-title">{translate("nomoves_ads_title")}</span>
                    <img loading="lazy" className="modals_area_img" src="/assets/magic_wand_modals/magic_wand_img_4.webp" />
                    <p className="modals_area-text">{translate("nomoves_ads_text")}</p>
                    <button type="button" className="modals_area-btn" onClick={() => GameUI.closePopup(Popups.OUT_MOVE_ADS_POPUP, true)}>{translate("nomoves_ads_btn")}</button>
                </div>
            </div>
        </div>
    )
}